// Objetivo: Contiene la sección de dirección del oferente en el formulario de indicadores
// Hooks
import { SelectorDireccionContainer } from 'hooks/Selectors/hooks';
//  Dirección GENERADOR
export const DireccionGenerador = ({
  errors,
  handleChange,
  isSubmitting,
  setFieldTouched,
  setFieldValue,
  touched,
  handleBlur,
  values
}) => {
  return (
    <>
      {/* Refactoring - direccion y mapa */}
      <SelectorDireccionContainer
        values={values}
        errors={errors}
        touched={touched}
        onChange={handleChange}
        handleBlur={handleBlur}
        setFieldTouched={setFieldTouched}
        setFieldValue={setFieldValue}
        isSubmitting={isSubmitting}
        nameRegion="regionOferente"
        nameComuna="comunaOferente"
        nameNombreVia="nombreNumeroViaOferente"
        subtitle=""
        className="grid grid-cols-12 gap-4 "
      />
    </>
  );
};

// * Oferente -> Generador
